const accessProduction = {
    PRODUCTION_INPUT: { name: 'Production Input', path: '/production-input' },
    OEE: { name: 'OEE', path: '/oee' },

    PRODUCT_LIST: { name: 'Product', path: '/product-list' },
    ADD_PRODUCT: { name: 'Add Product', path: '/add-product' },
    UPDATE_PRODUCT: { name: 'Edit Product', path: '/edit-product' },
    DELETE_PRODUCT: { name: 'Delete Product', path: '/delete-product' },
}

export default accessProduction;
